




















































import { Component, Vue } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';
import {
  RoleApiResponse,
} from '@/libs/api.interfaces';

Vue.use(VueRouter);

interface PermissionApiResponse {
  data: PermissionItem[];
}

@Component({
  components: {
    LayoutTitle,
    Select,
    FormInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Loader,
  },
})
export default class UserRoleFilter extends Vue {
  status: string[] = [];
  roles: { id: number; role: string }[] = [];
  role: { id: number; role: string }[] = [];

  filter() {
    this.$router.push({
      query: {
        status: this.status.length === 0 ? undefined : this.status.join(','),
        role: this.role.length === 0 ? undefined : this.role.map((e) => e.id).join(','),
      },
    });
  }

  mounted() {
    this.getRole();
  }

  clear() {
    this.status = [];
    this.role = [];
    this.$router.push({
      query: {
        status: undefined,
        role: undefined,
      },
    });
  }

  async getRole() {
    try {
      const { data } = await api.get<RoleApiResponse>('/user-roles', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: this.type === 'internal',
        },
      });
      this.roles = data.data.map((e) => ({
        id: e.id,
        role: e.role,
      }));

      this.parseParams();
    } catch (err) {
      console.error(err);
    }
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.status === 'string') {
      this.status = params.status.split(',');
    }

    if (typeof params.role === 'string') {
      const role = params.role.split(',');
      this.role = this.roles.filter((e) => role.includes(e.id.toString()));
    }
  }

  get type() {
    return this.$route.params.type;
  }
}
